import { GetterTree } from 'vuex';
import { GlobalClient, GlobalState } from './types';
import { RootState } from '../types';

export const getters: GetterTree<GlobalState, RootState> = {
  getClients(state): GlobalClient[] {
    return state.clients;
  },
};
